module.exports = __webpack_public_path__ + "static/media/sync.939fd8bd.svg";